import React from 'react';

import classNames from 'classnames';
import { parseEntities } from 'parse-entities';

import { HybridLink, Paragraph } from 'common/components';

import { LinkArrow } from 'components/LinkArrow/LinkArrow';
import { List } from 'components/List/List';

import './IconTitleColumns.scss';

type BlockTitleWithIconItems = {
  title?: string;
  icon?: React.ReactElement;
  listItems?: string[];
  text?: string;
  link?: string;
  isParse?: boolean;
  listColumnsNumber?: number;
  parseHTML?: boolean;
  listGapClass?: string;
  content?: React.ReactNode;
};

interface Props {
  items: BlockTitleWithIconItems[];
  iconTitleColumnsClass?: string;
  isMarkedList?: boolean;
  titleTextClass?: string;
  titleClass?: string;
  defaultIconTheme?: boolean;
}

export const IconTitleColumns = ({
  items,
  iconTitleColumnsClass = '',
  titleTextClass = '',
  titleClass = '',
  isMarkedList = false,
  defaultIconTheme = false,
}: Props) => (
  <div className={`icon-title-columns columns-${items.length} ${iconTitleColumnsClass}`}>
    {items.map(
      ({
        title,
        icon,
        listItems,
        text,
        link,
        isParse = true,
        listColumnsNumber = 1,
        parseHTML = false,
        listGapClass = 'small-list-gap',
        content,
      }) => (
        <div key={title} className="icon-title-item">
          {link ? (
            <HybridLink
              className={classNames('icon-title', {
                'icon-theme': !defaultIconTheme,
                titleClass,
              })}
              to={link}
            >
              <p>
                {' '}
                {icon && icon} {title && <span>{parseEntities(title)}</span>}
              </p>
            </HybridLink>
          ) : (
            <div
              className={classNames('icon-title', {
                'icon-theme': !defaultIconTheme,
                titleClass,
              })}
            >
              {icon && icon}
              {title && <h6>{parseEntities(title)}</h6>}
            </div>
          )}
          {!isMarkedList ? (
            <>
              {text && !parseHTML && (
                <div className={`icon-title-paragraph paragraph ${titleTextClass}`}>
                  {isParse ? parseEntities(text) : text}
                </div>
              )}

              {text && parseHTML && (
                <div
                  className="icon-title-custom"
                  dangerouslySetInnerHTML={{
                    __html: text,
                  }}
                />
              )}

              {listItems && (
                <List
                  items={listItems.map((value) => parseEntities(value))}
                  listClass={`without-list-mark list-top-padding ${listGapClass}`}
                  columnsNumber={listColumnsNumber}
                />
              )}
            </>
          ) : (
            <>
              {text && <Paragraph item={text} paragraphClass="icon-title-paragraph" />}
              {listItems && <List items={listItems} listClass="list-top-padding" columnsNumber={listColumnsNumber} />}
              {link && <LinkArrow link={link} />}
            </>
          )}
          {content}
        </div>
      ),
    )}
  </div>
);
